module.exports = __webpack_public_path__ + "707938c8b6b146b8416a0e05e4208e5c.svg";